export const passwordCardDeleteModal = {
	confirmButton: "Sim, desejo bloquear o cartão de senhas",
	text:
		"Em caso de perda de um cartão de senhas, é aconselhável bloqueá-lo. Ao confirmar	o bloqueio, seu histórico fica registrado, mas ele deixa de ser válido. Sendo	assim, deseja bloquear ",
	complement: {
		single: "o cartão de senhas de {{cardName}}?",
		multiple: "os cartões de senhas selecionados?",
	},
};
